import LoaderSuspense from './_loader-suspense.js'
import SportIcons from './_sport-icons.js'
import FlexPane from './_flex-pane.js'
import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableBorder from './_configurable-border.js'
import ConfigurableBackground from './_configurable-background.js'
import ConfigurableText from './_configurable-text.js'
import MenuRow from './_menu-row.js'
import Image from './_image.js'
import Text from './_text.js'
import EventsCoupon from './_events-coupon.js'
import MenuRowSkeleton from './_menu-row-skeleton.js'

export default {
  name: 'TopSports',
  values: {
    maxNumberOfSports: 5,
    showMenuSportIcon: false,
    showCouponSportIcon: false,
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {
        style: {
          container: {
            maxWidth: '100%',
          },
          hidden: {
            display: 'block',
            position: 'absolute',
            visibility: 'hidden',
            opacity: 0,
            zIndex: -1,
          },
        },
      },
    },
    eventCounter: {
      headerTotal: false,
      headerPerSport: true,
      footerSelectedSport: false,
    },
    sportIcons: {
      configSet: SportIcons,
      configValues: {},
    },
    showEventListMarketSelectors: true,
    displayEventListAsInplay: false,
    mainContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          _mobile_padding: '0 8px',
          flexDirection: 'column',
        },
      },
    },
    couponContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    style: {
      navigationHeaderContainer: {
        position: 'relative',
        $mixin: [
          {
            configSet: ConfigurablePadding,
          },
          {
            configSet: ConfigurableBorder,
          },
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
      navigationTitle: {
        padding: '0 64px 0 8px',
        _mobile_padding: '8px',
        $mixin: [
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurablePadding,
          },
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
    },
    navigationMenuContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          padding: '8px',
          boxSizing: 'border-box',
          maxWidth: '100%',
        },
      },
    },
    navigationMenu: {
      configSet: MenuRow,
      configValues: {
        style: {
          container: {
            flexDirection: 'row',
            width: 'auto',
            padding: '0',
          },
        },
        itemInnerContainer: {
          itemSpacing: '8px',
        },
        item: {
          unselected: {
            style: {
              base: {
                _mobile_flexDirection: 'column',
                flexGrow: 0,
                padding: '0 8px',
              },
            },
          },
          selected: {
            style: {
              base: {
                _mobile_flexDirection: 'column',
                flexGrow: 0,
                padding: '0 8px',
              },
            },
          },
        },
        buttonScrollPane: {
          contentContainer: {
            itemSpacing: '8px',
            style: {
              _mobile_padding: '0',
            },
          },
          scrollPaneContainer: {
            style: {
              padding: '0',
            },
          },
        },
      },
    },
    navigationMenuSportIcon: {
      configSet: Image,
      configValues: {},
    },
    navigationMenuSportText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    navigationMenuItemWrapper: {
      configSet: FlexPane,
      configValues: {
        style: {
          minWidth: '32px',
          alignItems: 'center',
          justifyContent: 'center',
        },
      },
    },
    eventsCoupon: {
      configSet: EventsCoupon,
      configValues: {
        enableContentLazyLoading: true,
        reportLoadingStatus: true,
        eventList: {
          showAllEventsButton: true,
          header: {
            showGameLineSwitcher: false,
            showTitle: true,
          },
          eventItem: {
            reportLoadingStatus: true,
          },
        },
      },
    },
    navigationMenuSkeleton: {
      configSet: MenuRowSkeleton,
      configValues: {
        _desktop_numberOfItems: 5,
        container: {
          itemSpacing: '8px',
          style: {
            padding: '8px',
            _desktop_flexGrow: 0,
          },
        },
        linkPlaceholder: {
          style: {
            width: '88px',
            height: '40px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
